import { combineReducers } from "redux"
import { login } from "./loginReducer"
import { forgotPassword } from "./forgotPassword"

const authReducers = combineReducers({
  login,
  forgotPassword
})

export default authReducers
